import { useMemo, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { PortalHeading } from "@/pages/portal/PortalLayout";
import { Textarea } from "@/components/ui/textarea";
import { useFetch } from "@/hooks/useFetch";
import { api, errMsg } from "@/lib/api";

export default function AdminMessages() {
  const { data, reload } = useFetch("/admin/messages");
  const [active, setActive] = useState(null);
  const [body, setBody] = useState("");
  const threads = useMemo(() => {
    const map = {};
    (data?.messages || []).forEach((m) => {
      const cid = m.from_staff ? m.to_user_id : m.from_user_id;
      if (cid) (map[cid] = map[cid] || []).push(m);
    });
    return map;
  }, [data]);
  const send = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/messages", { to_user_id: active, body }); setBody(""); reload(); } catch (err) { toast.error(errMsg(err)); }
  };
  const user = (id) => data?.users?.[id] || { email: id };
  return (
    <div data-testid="admin-messages">
      <PortalHeading title="Customer messages" />
      <div className="grid md:grid-cols-3 gap-4">
        <div className="rounded-2xl bg-white divide-y h-fit">
          {Object.keys(threads).map((cid) => (
            <button key={cid} onClick={() => setActive(cid)} data-testid={`admin-thread-${cid}`} className={`w-full text-left p-4 text-sm ${active === cid ? "bg-[#F86900]/10" : "hover:bg-black/5"}`}>
              <p className="font-semibold">{user(cid).name || user(cid).email}</p><p className="text-xs text-[#56585E] truncate">{threads[cid][0].body}</p>
            </button>
          ))}
          {!Object.keys(threads).length && <p className="p-4 text-sm text-[#56585E]">No messages yet.</p>}
        </div>
        <div className="md:col-span-2">
          {active ? (
            <>
              <div className="rounded-2xl bg-white p-4 space-y-2 max-h-[55vh] overflow-y-auto">
                {threads[active].slice().reverse().map((m) => (
                  <div key={m.id} className={`max-w-[80%] rounded-2xl px-4 py-2 text-sm ${m.from_staff ? "ml-auto bg-[#020165] text-white" : "bg-[#F4F4F4]"}`}>{m.body}</div>
                ))}
              </div>
              <form onSubmit={send} className="mt-3 flex gap-2">
                <Textarea required rows={2} value={body} onChange={(e) => setBody(e.target.value)} placeholder="Reply to customer…" data-testid="admin-message-input" />
                <button className="rounded-xl bg-[#F86900] px-4" data-testid="admin-message-send" aria-label="Send"><Send className="h-5 w-5" /></button>
              </form>
            </>
          ) : <p className="text-sm text-[#56585E]">Select a conversation.</p>}
        </div>
      </div>
    </div>
  );
}
